import { TournamentAdminRepository, TournamentRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class RemoveTournamentAdminUseCase {
  constructor(
    private tournamentRepository: TournamentRepository,
    private tournamentAdminRepository: TournamentAdminRepository
  ) {}

  async execute(params: {
    tournamentId: string;
    userId: string;
    requestingUserId: string; // El usuario que hace la petición
  }): Promise<void> {
    const { tournamentId, userId, requestingUserId } = params;

    logger.debug('RemoveTournamentAdmin', 'Removing admin', { tournamentId, userId });

    // Verificar que el torneo existe
    const tournament = await this.tournamentRepository.getById(tournamentId);
    if (!tournament) {
      throw new Error('Tournament not found');
    }

    // Verificar que el usuario que hace la petición es el dueño
    if (tournament.userId !== requestingUserId) {
      throw new Error('Only the tournament owner can remove administrators');
    }

    // Verificar que no se intente remover al dueño
    if (tournament.userId === userId) {
      throw new Error('Cannot remove tournament owner');
    }

    // Remover el admin
    await this.tournamentAdminRepository.deleteByUserAndTournament(userId, tournamentId);

    logger.debug('RemoveTournamentAdmin', 'Admin removed successfully');
  }
}